import { ICardElementWithChildren } from "../model/model";

const createUICardElement = <T extends {}>(
  id: string,
  typename: string,
  data: T
): T & ICardElementWithChildren => {
  return {
    ...data,
    id,
    name: (data as any).name || "",
    children: [],
    symbol: "",
    typename,
    owner: "",
    topelement: "",
    periodlevel: "",
    periodlevelname: "",
  };
};

export default createUICardElement;
